@use '@lib/assets/styles/main.scss' as *;

$imageSize: 88px;

.root {
  display: grid;
  @include responsive($md1) {
    grid-template-columns: $imageSize auto;
    grid-column-gap: 24px;
  }
  @include responsive(null, $md1) {
    grid-row-gap: 16px;
  }
}

.img {
  img, svg {
    @extend %userAvatarImage;
    width: $imageSize;
    height: $imageSize;
  }
}

.content {
  margin-bottom: 16px;
}

.fileName {
  margin-bottom: 2px;
  line-height: 20px;
  min-height: 20px;
  display: block;
}

.validationMsg {
  color: $gray400
}

.actions {
  display: flex;
  gap: 16px;
}
